import { Input, Textarea } from '@fluentui/react-components';
import { useOtherInfoContext } from '../OtherInfoContext';
import { isFieldReadOnly } from '../fieldReadOnly';
import { FieldWrapper } from './FieldWrapper';
import type { FieldComponentProps } from './types';

export const StringField = ({
  field,
  fieldValue,
  isFieldDisabled,
  isSaved,
  validationMessage,
}: FieldComponentProps) => {
  const { handleOtherInfoChange, validateField } = useOtherInfoContext();

  if (field.rows) {
    return (
      <FieldWrapper field={field} validationMessage={validationMessage}>
        <Textarea
          id={field.name}
          resize="vertical"
          onChange={(_, newValue) => {
            handleOtherInfoChange(field.name, newValue.value);
            validateField(field.name, newValue.value);
          }}
          value={fieldValue == null ? '' : String(fieldValue)}
          readOnly={isSaved || isFieldReadOnly(field)}
          disabled={isFieldDisabled}
          rows={field.rows ?? 3}
          maxLength={field.maxLength}
        />
      </FieldWrapper>
    );
  }

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      <Input
        id={field.name}
        onChange={(_, newValue) => {
          handleOtherInfoChange(field.name, newValue.value);
          validateField(field.name, newValue.value);
        }}
        type="text"
        value={fieldValue == null ? '' : String(fieldValue)}
        disabled={isFieldDisabled}
        readOnly={isSaved || isFieldReadOnly(field)}
        maxLength={field.maxLength}
      />
    </FieldWrapper>
  );
};
